module.exports = __webpack_public_path__ + "static/media/pecuaria-6.29fd2e42.jpg";